import * as React from "react"
export const Cog = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    className="stroke-fg-1"
    {...props}>
    <path
      d="M9.18393 3.59776C9.53927 2.13408 11.6209 2.13408 11.9762 3.59776C12.2058 4.54327 13.289 4.99198 14.1199 4.48571C15.4062 3.70199 16.8781 5.17392 16.0944 6.46015C15.5881 7.29105 16.0368 8.37431 16.9823 8.60386C18.446 8.95919 18.446 11.0408 16.9823 11.3961C16.0368 11.6257 15.5881 12.709 16.0944 13.5398C16.8781 14.8261 15.4062 16.298 14.1199 15.5143C13.289 15.008 12.2058 15.4567 11.9762 16.4022C11.6209 17.8659 9.53927 17.8659 9.18393 16.4022C8.95439 15.4567 7.87112 15.008 7.04023 15.5143C5.754 16.298 4.28207 14.8261 5.06579 13.5398C5.57206 12.709 5.12335 11.6257 4.17784 11.3961C2.71416 11.0408 2.71416 8.95919 4.17784 8.60386C5.12335 8.37431 5.57206 7.29105 5.06579 6.46015C4.28207 5.17392 5.754 3.70199 7.04023 4.48571C7.87112 4.99198 8.95439 4.54327 9.18393 3.59776Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0801 10C13.0801 11.3807 11.9608 12.5 10.5801 12.5C9.19937 12.5 8.08008 11.3807 8.08008 10C8.08008 8.61929 9.19937 7.5 10.5801 7.5C11.9608 7.5 13.0801 8.61929 13.0801 10Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
